export * from "../global/stars-shinning";
